import { StatusChip } from '@/components/ui/status-chip';
import type { SearchUserSubaccount } from '@/services/api/users';

interface SubaccountMatchProps {
  subaccount: SearchUserSubaccount;
}

export const SubaccountMatch = ({ subaccount }: SubaccountMatchProps) => (
  <span className="flex items-center gap-2 whitespace-nowrap text-xs text-muted-foreground" title={subaccount.pid ?? undefined}>
    <StatusChip className="px-2 py-0.5 text-xs" variant="info">
      Subaccount
    </StatusChip>
    matched via <span className="font-mono">{subaccount.fastId}</span>
  </span>
);
SubaccountMatch.displayName = 'SubaccountMatch';
